<vitens-header *ngIf="isAuthenticated"></vitens-header>

<router-outlet></router-outlet>

<ng-http-loader [debounceDelay]="300" [extraDuration]="300">
</ng-http-loader>

<ng-container *ngIf="currentEnv === 'mock' && isAuthenticated">
	<vitens-event-trigger></vitens-event-trigger>
</ng-container>